import { useLocation, useNavigate } from 'react-router-dom';

import { ETL_INTEGRATION_TYPE, ETLConfiguration, Values } from '../components/configuration/types';
import { PATH_EDIT_CONFIGURATION, PATH_MY_CONFIGURATIONS, PATH_NEW_CONFIGURATION } from '../router/routes';

export const useSearchNavigate = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  const navigateToMyConfigurations = () => {
    navigate(`/${PATH_MY_CONFIGURATIONS}${search}`);
  };

  const navigateToNewIntegrationPicker = () => {
    navigate(`/${PATH_MY_CONFIGURATIONS}/${PATH_NEW_CONFIGURATION}${search}`);
  };

  const navigateToEditIntegration = (configuration: ETLConfiguration) => {
    navigate(
      `/${PATH_MY_CONFIGURATIONS}/${PATH_EDIT_CONFIGURATION}/${configuration.integration.toLowerCase()}/${
        configuration.id
      }${search}`
    );
  };

  const navigateToNewIntegrationType = (type: Values<typeof ETL_INTEGRATION_TYPE>) => {
    navigate(`/${PATH_MY_CONFIGURATIONS}/${PATH_NEW_CONFIGURATION}/${type.toLowerCase()}${search}`);
  };

  return {
    navigateToMyConfigurations,
    navigateToNewIntegrationType,
    navigateToNewIntegrationPicker,
    navigateToEditIntegration,
  };
};
